import type { FaireProductEntity } from "../../entity_types/product";

export const p_wddmj89v8v: FaireProductEntity = {
  token: "p_wddmj89v8v",
  type: "product",
  name: "Hand Dyed Bamboo Socks (9 Colors)",
  brandToken: "b_21vc5x7n3h",
  brandName: "Mira Blackman",
  imageUrl:
    "https://cdn.faire.com/fastly/be7c05210559f2eb5ec2d2da9b1a0c0b8b71e230faba1c0ac75bddab4e82d7d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2223eebaee502100d91c136bbfe24d066f6b22f09dd1092cf1cfe9cf70d7247c.jpeg",
    "https://cdn.faire.com/fastly/d587ac235b93fe276ac9640dff8a57da602b195b6bbda3937f6b79919d143406.jpeg",
    "https://cdn.faire.com/fastly/f0ddd7a855cf56b9839fb40fad39a7f3d17cfd569d7465b8bc73c45697729382.jpeg",
    "https://cdn.faire.com/fastly/55e5ef2260968248ab28ae211f93133cf8fc5e7dd94c4f7e6e8a67983f7d0895.jpeg",
    "https://cdn.faire.com/fastly/a93d77c95f25a93fa9772a7dbb3a416edbf29c1dbbd74fcd207d73bc61052fb4.jpeg",
    "https://cdn.faire.com/fastly/be93ef08b384fb0c0fc74fc3dc6c03b72bc3eeced88b529695066c2ffb736cdf.jpeg",
    "https://cdn.faire.com/fastly/b38bf8a8fc705bdff1ba3a0aea09ce942db99077a957232a73e247d398c23455.jpeg",
    "https://cdn.faire.com/fastly/c910f359e3b1efe89d053cf7ed292bdb424ce8092b6f48a3fd825435ec2c6b5e.jpeg",
    "https://cdn.faire.com/fastly/509c376f80ae35dea0dc765f8d41cd44f6f9d844b0e7349c4451864536579638.jpeg",
    "https://cdn.faire.com/fastly/5ffe16ffc5e012aa7b21aeb1080e7eb42abf64dace64696a62c6256cc1a1e78e.jpeg",
  ],
  priceDollars: 11,
  description:
    "Indulge in Everyday Luxury with Our Hand-Dyed Bamboo Rayon Socks\n\nWrap your feet in the softest, dreamiest comfort you’ve ever experienced. Made from sustainable bamboo rayon, these socks are irresistibly soft, lightweight, and cozy. Whether worn fully extended or stylishly scrunched down, they add effortless charm to any outfit.\n\nEach pair is uniquely hand-dyed in our backyard studio, where art meets nature. The ever-changing elements—like the day’s temperature or a gentle breeze—add a touch of magic to the process, making every pair truly one of a kind. Experience the perfect blend of comfort, craftsmanship, and individuality.\n\nActual colors and patterns will vary. I use the same dye method on all these pieces but each one is distinct from the next. Colors may vary slightly also due to the fact that every computer monitor has a different capability to display colors and that everyone sees these colors differently.\n\n• Fits up to a women's size 11/men's size 9",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:34.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
